import * as React from "react";
import ObProductTypeSelect from "./obProductTypeSelect";
import EdButton from "../../../generic/edButton";
import ObCheckbox from "../generic/obCheckbox";
import { AEqConvertPos } from "../../../service/orderBook/obApiService";
import ObAssetDetailPopup from "../generic/obAssetDetailPopup";
import ObToastMessPopup from "../generic/obToastMessPopup";
import ee from "../../../utils/eventEmitter";
import ObTradeTabContent from "./obTradeTabContent";
import { backButtonValue } from "../obJsXConstants";
import DeviceContext from "./../../../service/indentifyDevice";
import "../../../../assets/scss/components/generic/layout/layoutDesk.scss";
import { IListObj } from "../../../types/genericTypes";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/orderBook/obConvertPositions/obConvertPositionDesk.scss");
} else {
	require("../../../../assets/scss/components/toc/orderBook/obConvertPositions/obConvertPositionTab.scss");
}

export interface IObEquityConvertDeskProps {
	data: Array<any>;
	onBackClick: (event?: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
}

const ObEquityConvertDesk: React.FC<IObEquityConvertDeskProps> = (props) => {
	const [tradeData, setTradeData] = React.useState(
		props.data.map((data, index) => {
			return { ...data, id: index, isSelected: false };
		})
	);

	const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);

	// show convertion error popup
	const [conErrorPopupMsg, setConErrorPopupMsg] = React.useState<string>();

	const [isProcessing, setIsProcessing] = React.useState(false);

	// total qty of selected rows
	const totalSelectedQty = tradeData.reduce((a, b) => {
		if (b.isSelected) {
			return a + +b.qty;
		} else {
			return a;
		}
	}, 0);

	const navigationDropdownOptions: Array<IListObj> = [
		{ value: "NRML", display: "NRML" },
		{ value: "MIS", display: "MIS" },
		{ value: "MTF", display: "MTF" },
		{ value: "BO", display: "BO" },
		{ value: "CO", display: "CO" }
	];

	let selectedPrdCode: string;

	let ordConvertedSuccList: Array<string> = [],
		ordConvertedFailList: Array<{ error: any; index: number }> = [],
		OrdsListToConvert: Array<string> = [];
	// runs after all convert api response
	function convertCallback(res: any, index: number) {
		if (res.data) {
			// if success
			ordConvertedSuccList.push(res.data);
		} else {
			// if error
			ordConvertedFailList.push({ error: res.error, index });
		}
		// when we get all the responses
		if (ordConvertedSuccList.length + ordConvertedFailList.length === OrdsListToConvert.length) {
			setIsProcessing(false);

			if (ordConvertedSuccList.length === OrdsListToConvert.length) {
				// when all the converted successfully
				ee.emit("showToast", { message: `Success - ${totalSelectedQty} qty converted to ${selectedPrdCode}`, color: "success" }); //show toast message
				props.onBackClick();
			} else if (ordConvertedFailList.length === OrdsListToConvert.length) {
				// when all request failed
				ee.emit("showToast", {
					message: (
						<span>
							Could not convert selected positions{" "}
							<button className="hyper_link" onClick={() => setConErrorPopupMsg(ordConvertedFailList[0].error.errMsg)}>
								know more
							</button>
						</span>
					),
					color: "error"
				}); //show toast message
			} else {
				// partial conversion
				ee.emit("showToast", {
					message: `Could not convert ${ordConvertedFailList.length} / ${OrdsListToConvert.length} selected positions`,
					color: "error"
				}); //show toast message
				props.onBackClick();
			}
		}
	}

	function onConvertPosition(selectedRadio: string) {
		setIsProcessing(true);
		selectedPrdCode = selectedRadio;

		// call api for all selected rows
		tradeData.forEach((rw: any, index: number) => {
			if (rw.isSelected) {
				OrdsListToConvert.push(rw.ordID);
				AEqConvertPos((res: any) => convertCallback(res, index), {
					nstOID: rw.ordID,
					flID: rw.flID,
					prdCode: rw.prdCode,
					prdCodeCh: selectedRadio,
					exc: rw.exc,
					ordTyp: rw.ordType
				});
			}
		});
	}

	function obEqtradeRowSelection(index: number) {
		// if checkbox of any row is selected
		if (index >= 0) {
			// copy the data
			const data = [...tradeData];
			// get the row
			const row = { ...data[index] };
			// invert the status
			row.isSelected = !tradeData[index].isSelected;

			// put the updated row back in data
			data[index] = row;
			// set the state
			setTradeData(data);

			// set the value of all selected checkbox
			data.every((row) => row.isSelected === true) ? setIsAllDataSelected(true) : setIsAllDataSelected(false);
		}
		// if all clicked on all selected checkbox
		else if (index === -1) {
			// copy the data
			let data = [...tradeData];
			// loop over the data
			// If isAllDataSelected is true, then set every row to false
			// else if isAllDataSelected is false, then set every row to true
			data = data.map((row) => ({ ...row, isSelected: !isAllDataSelected }));

			setTradeData(data);

			// invert the state of isAllDataSelected
			setIsAllDataSelected(!isAllDataSelected);
		}
	}

	return (
		<section className="outer_container eq_conv_desk_wrap">
			<section className="ob_container lyCont eq_conv_container">
				<section className="list_view">
					<div className="ly_list_view">
						<div className="lv_menu">
							<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
						</div>
					</div>
					<div className="ob_right_cont ly_right_cont">
						<div className="sel_trade">
							<div className="ob_eq_convert_con">
								<h2 className="trd_tit">Select Trade</h2>
								<div className="select_hdr">
									<div className="check_box">
										<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => obEqtradeRowSelection(-1)}>
											Select All
										</ObCheckbox>
									</div>
									<div className="total_sel_count">
										<span>3</span>selected
									</div>
								</div>
								<ul className="ob_conver_tbl">
									{tradeData.map((data, index) => (
										<ObTradeTabContent
											isSelected={data.isSelected}
											onSelect={() => obEqtradeRowSelection(index)}
											showCheckbox={true}
											tooltipTxt={ordConvertedFailList.find((failObj) => failObj.index === index)?.error.errMsg}
											key={index}
											data={data}
										/>
									))}
								</ul>
							</div>
						</div>
						<div className="prod_type_layout">
							<ObProductTypeSelect
								list={navigationDropdownOptions}
								numOfQty={totalSelectedQty}
								onConvertPosition={onConvertPosition}
								isProcessing={isProcessing}
							/>
						</div>
					</div>
				</section>
			</section>
			{conErrorPopupMsg && (
				<ObAssetDetailPopup>
					<ObToastMessPopup
						title="Error in Conversion"
						subtitle={conErrorPopupMsg}
						buttonValue="Okay"
						btnTyp="blue-link"
						onBackClick={() => setConErrorPopupMsg(undefined)}
						onToastBtnClick={() => setConErrorPopupMsg(undefined)}
					/>
				</ObAssetDetailPopup>
			)}
		</section>
	);
};

export default ObEquityConvertDesk;
